import { render, staticRenderFns } from "./class_readppt.vue?vue&type=template&id=f4b50368&scoped=true"
import script from "./class_readppt.vue?vue&type=script&lang=js"
export * from "./class_readppt.vue?vue&type=script&lang=js"
import style0 from "./class_readppt.vue?vue&type=style&index=0&id=f4b50368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b50368",
  null
  
)

export default component.exports